import { getLayoutModeCameraControlsOrNull } from '../../three/reactThreeFiberBindings';
import {
  changeCameraIfNeeded,
  focusCameraOnSelectedObjectOrFallback,
  setPropertiesForActiveCamera,
} from '../../three/ThreeJsSceneActions';
import { isPanningDisabled } from '../selectors/isPanningDisabled';
import { getCurrentCameraTypeAndProperties } from '../slices/camera/selectors';
import { selectorHandlerFactory } from './utility';

export const panRestrictionsHandler = selectorHandlerFactory(isPanningDisabled, (change) => {
  const layoutModeCameraControls = getLayoutModeCameraControlsOrNull();
  if (layoutModeCameraControls) layoutModeCameraControls.enablePan = !change.currentState;
});

export const cameraPropertiesHandler = selectorHandlerFactory(getCurrentCameraTypeAndProperties, (change) => {
  const [type, properties] = change.currentState;

  changeCameraIfNeeded(type);

  if (properties) {
    setPropertiesForActiveCamera(properties);
  } else {
    // If the camera's properties in redux state are `null` the camera has not been used yet. Focusing on the selected
    //   object will get the camera set up correctly and store its initial properties in redux state.
    focusCameraOnSelectedObjectOrFallback();
  }
});
